import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { CashButton } from './CashPrimitives';
/** One context row for the current task, its return path and local actions. */
export function CashSectionHeading({ title, backLabel, onBack, actions }) {
    const heading = useRef(null);
    useEffect(() => { heading.current?.focus({ preventScroll: true }); }, [title]);
    return _jsxs("header", { className: "cash-section-heading", children: [backLabel && onBack && _jsxs(CashButton, { className: "cash-task-return", onClick: onBack, children: [_jsx("span", { "aria-hidden": "true", children: "\u2190" }), backLabel] }), _jsx("h1", { ref: heading, "data-cash-section-heading": true, tabIndex: -1, children: title }), actions && _jsx("div", { className: "cash-actions", children: actions })] });
}
